import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Filter from '../../../components/Filter/Filter';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../../components/Filter/Filter.styles';
import TextInput from '../../../components/TextInput/TextInput';
import DateInput from '../../../components/DateInput/DateInput';
import MaskField from '../../../components/MaskField/MaskField';
import SelectOptions from '../../../components/SelectOptions/SelectOptions';
import Button from '../../../components/Button/Button';
import { theme } from '../../../styles/theme';
import { ImSearch } from 'react-icons/im';
import { LoadingContainer } from '../../GerenciarClientes/styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';
import Table from '../../../components/Table/Table';
import formatCPF from '../../../utils/functions/formatCPF';
import formatCNPJ from '../../../utils/functions/formatCNPJ';
import useCallFilter from '../../../utils/hooks/useCallFilter';
import { pixKeysFetchAction } from '../../../store/fetchActions/pixKeysActions';

const { secondaryColor, rbmBlack, mainColor } = theme.colors;

const Extracts = () => {
  const {
    dataPixKeys,
    loadingPixKeys,
    errorLoadingPixKeys,
    paginationPixKeys,
    errorMessagePixKeys,
  } = useSelector((state) => state.pixKeys);

  const [filterData, setFilterData] = useState('');
  const [filter, setFilter] = useState({
    search: '',
    limit: 10,
    page: 1,
    dataInicial: '',
    dataFinal: '',
    chave: '',
    tipoChave: '',
    conta: '',
  });

  const { handleSubmit, control } = useForm({});

  useCallFilter(filterData, setFilter, pixKeysFetchAction, 0, 0);

  const filterTable = (data) => {
    setFilterData(data);
  };

  const arrayKindOfKeys = [
    { ID: 'CPF', NOME: 'CPF' },
    { ID: 'Telefone', NOME: 'Telefone' },
    { ID: 'Email', NOME: 'Email' },
    { ID: 'Chave Aleatória', NOME: 'Chave Aleatória' },
  ];

  const pageOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  const body = dataPixKeys?.map((key) => {
    return {
      data: [
        { info: key.DATA_INSERCAO, align: 'center' },
        { info: key.NOME, align: 'left' },
        {
          info:
            key.CPFCNPJ?.length > 11
              ? formatCNPJ(key.CPFCNPJ)
              : formatCPF(key.CPFCNPJ),
          align: 'left',
        },
        { info: key.CHAVE, align: 'left' },
        { info: key.TIPO_CHAVE, align: 'center' },
        { info: key.AGENCIA, align: 'center' },
        { info: key.CONTA, align: 'center' },
      ],
    };
  });

  const header = [
    {
      id: 'data de registro',
      name: 'DATA INSERÇÂO',
      align: 'center',
    },
    {
      id: 'nome',
      name: 'CLIENTE',
      align: 'left',
    },
    {
      id: 'cpf/cnpj',
      name: 'CPF/CNPJ',
      align: 'left',
    },
    {
      id: 'chave',
      name: 'CHAVE',
      align: 'left',
    },
    {
      id: 'tipo chave',
      name: 'TIPO CHAVE',
      align: 'center',
    },
    {
      id: 'agencia',
      name: 'AGÊNCIA',
      align: 'center',
    },
    {
      id: 'conta',
      name: 'CONTA',
      align: 'center',
    },
  ];

  return (
    <>
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextInput
                label="Nome ou CPF/CNPJ"
                name={'search'}
                width={'25.042vw'}
                control={control}
                inputProps={{ role: 'filter-text-input' }}
              />
              <TextInput
                label="Chave"
                name={'chave'}
                width={'25.042vw'}
                control={control}
                inputProps={{ role: 'filter-text-input' }}
              />
              <SelectOptions
                label="Tipo de Chave"
                name={'tipoChave'}
                width={'15.042vw'}
                control={control}
                options={arrayKindOfKeys}
                initialName={'Todos'}
                initialValue={0}
              />
              <MaskField
                label="Conta"
                name="conta"
                mask="999999999999999"
                width={'25.042vw'}
                control={control}
              />
            </FirstFilterLine>
            <FirstFilterLine style={{ justifyContent: 'flex-start' }}>
              <DateInput
                label="Data Inicial"
                name={'dataInicial'}
                margin={'0'}
                control={control}
              />
              <DateInput
                label="Data Final"
                name={'dataFinal'}
                margin={'0'}
                control={control}
              />
              <Button
                backgroundColor={secondaryColor}
                width={'16.042vw'}
                hoverBGColor={mainColor}
                hoverColor={rbmBlack}
                color={'white'}
                type="submit"
                roleName="button-buscar-relatorios"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <h5>Resultados por Página</h5>
              <SelectOptions
                control={control}
                options={pageOptions}
                name={'limit'}
                margin={'0 0 0 1.875vw'}
                initialName={10}
                initialValue={10}
              />
              <h5>Total de Registros: {paginationPixKeys?.totalResult ?? 0}</h5>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingPixKeys ? (
          <LoadingContainer>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <Table
            loading={loadingPixKeys}
            error={errorLoadingPixKeys}
            hasPagination={true}
            filter={filter}
            pagination={paginationPixKeys}
            setFilter={setFilter}
            errorMessage={errorMessagePixKeys}
            filterTable={filterTable}
            body={body}
            header={header}
            limit={filter.limit}
          />
        )}
      </div>
    </>
  );
};

export default Extracts;
